module.exports = __webpack_public_path__ + "img/41.b8458792.png";